module.exports = __webpack_public_path__ + "img/errorIcon.e269513b.png";